import { render, staticRenderFns } from "./StudioToolShell.vue?vue&type=template&id=6d2f6704&scoped=true"
import script from "./StudioToolShell.vue?vue&type=script&lang=js"
export * from "./StudioToolShell.vue?vue&type=script&lang=js"
import style0 from "./StudioToolShell.vue?vue&type=style&index=0&id=6d2f6704&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2f6704",
  null
  
)

export default component.exports